import React from "react";
import DashboardTable from "../dashboard/DashboardTable";
import { GetBottleOrderColumns } from "./bottleOrderColumns";
import { getBottleOrderDashboard } from "../../services/bottleOrderService";

export default function BottleOrdersTable({ accountNumber }) {
  const bottleOrderColumns = React.useMemo(() => GetBottleOrderColumns(), []);

  if (!accountNumber) {
    return (
      <h3>
        You must select an account that you have access to from the main screen
      </h3>
    );
  }

  return (
    <DashboardTable
      accountNumber={accountNumber}
      title={"Bottle Orders"}
      columns={bottleOrderColumns}
      getData={getBottleOrderDashboard}
      color={"info"}
      isFromBottleOrder={true}
    />
  );
}